import React, { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import { getCoverForDriverUnder25 } from 'scenes/motor/selectors';
import { SingleYesNoStep } from 'scenes/common/components/Steps';

export const QUESTION =
  'Do you need cover for drivers under the age of 25 years?';
const COVER_FOR_DRIVER_UNDER_25 = 'coverForDriversUnder25';
const HELP_TEXT_ELEMENT = (
  <div style={{ paddingBottom: '2rem' }}>
    <br />
    Please select this option if any driver under 25 will be using your car.
    <br />
    <br />
    (Not required for learner drivers as long as the supervising driver’s age is
    25 years or older).
  </div>
);

const CoverForDriversUnder25Step: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={COVER_FOR_DRIVER_UNDER_25}
    helpText={HELP_TEXT_ELEMENT}
    defaultStateValue={getCoverForDriverUnder25(funnelState)}
    onNext={onNext}
  />
);

export default CoverForDriversUnder25Step;
